import styled from "styled-components/macro";
import { StyledButton } from "../../components/shared/Button/Button.styles";

export const LandingFeedbackContainer = styled.div`
  margin-top: 20px;
  max-width: 802px;
  width: 100%;
`;

export const LandingFeedbackCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.white};
  box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
`;

export const LandingFeedbackCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LandingFeedbackButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;

  ${StyledButton} {
    width: 100%;
    max-width: 100%;
    font-weight: 700;
  }

  @media (min-width: 1201px) {
    justify-content: flex-end;

    ${StyledButton} {
      max-width: fit-content;
    }
  }
`;
